import { useState, useEffect } from 'react';

const useDOMWidth = (domWidth) => {
	const [width, setWidth] = useState(domWidth);

	useEffect(() => {
		window.onresize = (e) => {
			let width = window.innerWidth;
			if (width !== domWidth) {
				setWidth(width);
			}
		};
	}, [domWidth]);

	return { width };
};

export default useDOMWidth;
